import {
  PaymentElement,
  useElements,
  useStripe,
} from "@stripe/react-stripe-js";
import React, { useState } from "react";
import Button from "../Button";
import { toast } from "react-toastify";
import { getDriver } from "../../apis/services/create-service";

interface CheckoutFormProps {
  onSuccessfullPayment: (id: string) => void;
  isSubmittingForm: boolean;
  isDriverSelected: boolean;
  amount: string;
  scheduleTime: Date | null;
  driverId: string;
}

const CheckoutForm = ({
  onSuccessfullPayment,
  isSubmittingForm,
  isDriverSelected,
  amount,
  driverId,
  scheduleTime,
}: CheckoutFormProps) => {
  const [isSubmitting, setIsSubmitting] = useState(false);
  const stripe = useStripe();
  const elements = useElements();

  const handlePayment = async () => {
    if (!stripe || !elements || !isDriverSelected) return;

    setIsSubmitting(true);

    const driverFound = await getDriver({
      assignedDriverId: driverId,
      scheduleTime: scheduleTime ? scheduleTime?.toISOString() : null,
    });

    if (!driverFound?.success) {
      toast.error(
        driverFound?.error?.error || "Driver is currently unavailable"
      );
      setIsSubmitting(false);
      return;
    }

    const { error, paymentIntent } = await stripe.confirmPayment({
      elements,
      redirect: "if_required",
    });

    setIsSubmitting(false);
    if (error) {
      toast.error(error.message);
      console.log(error, "error");
      return;
    }

    console.log(paymentIntent, "paymentIntent");

    onSuccessfullPayment(paymentIntent?.id);
  };

  return (
    <div>
      <PaymentElement />
      <div className="flex mt-4 items-center justify-center">
        <Button
          isLoading={isSubmitting || isSubmittingForm}
          onClick={handlePayment}
          className="w-32 min-h-0 h-10 md:h-10"
        >
          Pay $ {amount}
        </Button>
      </div>
    </div>
  );
};

export default CheckoutForm;
